import image from './images/img_0.png'

export default {
  v: "5.5.9",
  fr: 24,
  ip: 0,
  op: 192,
  w: 1000,
  h: 1000,
  nm: "01M_Virus",
  ddd: 0,
  assets: [
    { id: "image_0", w: 6000, h: 5000, u: "", p: image, e: 0 },
    {
      id: "comp_0",
      layers: [
        {
          ddd: 0,
          ind: 1,
          ty: 2,
          nm: "science03b.png",
          cl: "png",
          refId: "image_0",
          sr: 1,
          ks: {
            o: { a: 0, k: 100, ix: 11 },
            r: {
              a: 1,
              k: [
                {
                  i: { x: [0.667], y: [1] },
                  o: { x: [0.333], y: [0] },
                  t: 0,
                  s: [0],
                },
                {
                  i: { x: [0.667], y: [1] },
                  o: { x: [0.333], y: [0] },
                  t: 17.644,
                  s: [3],
                },
                {
                  i: { x: [0.667], y: [1] },
                  o: { x: [0.333], y: [0] },
                  t: 43.589,
                  s: [-6],
                },
                {
                  i: { x: [0.667], y: [1] },
                  o: { x: [0.333], y: [0] },
                  t: 68.497,
                  s: [4],
                },
                {
                  i: { x: [0.667], y: [1] },
                  o: { x: [0.333], y: [0] },
                  t: 96.519,
                  s: [-2],
                },
                {
                  i: { x: [0.667], y: [1] },
                  o: { x: [0.333], y: [0] },
                  t: 119.352,
                  s: [3],
                },
                {
                  i: { x: [0.667], y: [1] },
                  o: { x: [0.333], y: [0] },
                  t: 146.335,
                  s: [-3],
                },
                {
                  i: { x: [0.667], y: [1] },
                  o: { x: [0.333], y: [0] },
                  t: 170.205,
                  s: [5],
                },
                { t: 192, s: [0] },
              ],
              ix: 10,
            },
            p: {
              a: 1,
              k: [
                {
                  i: { x: 0.833, y: 0.833 },
                  o: { x: 0.167, y: 0.167 },
                  t: 0,
                  s: [504.121, 264.197, 0],
                  to: [-81.667, -4.333, 0],
                  ti: [-5.089, -143.208, 0],
                },
                {
                  i: { x: 0.833, y: 0.833 },
                  o: { x: 0.167, y: 0.167 },
                  t: 24,
                  s: [288.121, 416.197, 0],
                  to: [5.17, 145.504, 0],
                  ti: [23.1, -179.406, 0],
                },
                {
                  i: { x: 0.833, y: 0.833 },
                  o: { x: 0.167, y: 0.167 },
                  t: 71,
                  s: [714.121, 664.197, 0],
                  to: [-23.51, 182.593, 0],
                  ti: [12.54, 126.977, 0],
                },
                {
                  i: { x: 0.833, y: 0.833 },
                  o: { x: 0.167, y: 0.167 },
                  t: 120,
                  s: [287.121, 687.197, 0],
                  to: [-20.661, -209.211, 0],
                  ti: [-6.035, 157.997, 0],
                },
                {
                  i: { x: 0.833, y: 0.833 },
                  o: { x: 0.167, y: 0.167 },
                  t: 168,
                  s: [707.121, 416.197, 0],
                  to: [4.344, -113.721, 0],
                  ti: [64.593, -0.451, 0],
                },
                { t: 192, s: [504.121, 264.197, 0] },
              ],
              ix: 2,
            },
            a: { a: 0, k: [3000, 2500, 0], ix: 1 },
            s: { a: 0, k: [7, 7, 100], ix: 6 },
          },
          ao: 0,
          ip: 0,
          op: 192,
          st: 0,
          bm: 0,
        },
      ],
    },
  ],
  layers: [
    {
      ddd: 0,
      ind: 1,
      ty: 0,
      nm: "01E_Virus",
      refId: "comp_0",
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [500, 500, 0], ix: 2 },
        a: { a: 0, k: [500, 500, 0], ix: 1 },
        s: { a: 0, k: [100, 100, 100], ix: 6 },
      },
      ao: 0,
      w: 1000,
      h: 1000,
      ip: 0,
      op: 144,
      st: -48,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 2,
      ty: 0,
      nm: "01E_Virus",
      refId: "comp_0",
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [500, 500, 0], ix: 2 },
        a: { a: 0, k: [500, 500, 0], ix: 1 },
        s: { a: 0, k: [100, 100, 100], ix: 6 },
      },
      ao: 0,
      w: 1000,
      h: 1000,
      ip: 144,
      op: 192,
      st: 144,
      bm: 0,
    },
  ],
  markers: [],
};
